import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarXMLPendentes(api) {
    let parametros = {
      operacao: 'buscarAnalisesXMLPendentes'
    }
    let retorno = {};
    
    await api.santriGET('/rest/analiseAutomaticaXMLEntrada' , parametros, 15, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })
  
  
      return retorno;
  },
}


// WEBPACK FOOTER //
// ./src/components/Rest/RAnaliseAutomaticaXMLEntrada.js